import AuthService from 'services/axios/AuthService';
import axios from 'axios';
import { apiBaseURL } from 'config/axios';
import { Storage } from '@capacitor/core';

const axiosInstance = () => {
  const defaultOptions = {
    baseURL: apiBaseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async config => {
    const ret = await Storage.get({ key: 'token' });
    const token = JSON.parse(ret?.value);
    config.headers.Authorization = `${token?.token_type} ${token?.access_token}`;
    return config
  }, (error) => {
    return Promise.reject(error)
  })

  instance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config;
    let message = {
      message: 'Error',
      errors: ''
    }
    if (!error.response) {
      message = {
        message: 'Error en conexión',
        errors: "No se pudo establecer una conexión con el servidor."
      }
      return Promise.reject(message);
    }
    if (error.response.status === 500 && originalRequest.url === `${apiBaseURL}/auth/refresh`) {
      await AuthService.logout();
      window.location.href = `login`;
      return Promise.reject(error);
    }
    if (error.response.status === 500) {
      message = {
        message: 'Error en servidor: ' + JSON.stringify(error.response.data.message),
        errors: error.response.data.message
      }
      return Promise.reject(message);
    }
    if (error.response.status === 401) {
      const token = await AuthService.refreshToken();
      axios.defaults.headers.common['Authorization'] = `${token?.token_type} ${token?.access_token}`;
      return instance(originalRequest);
    }
    if (error.response.status === 422) { //unprocessable entity
      const errorMessage = {
        message: error.response.data.message,
        errors: Object.values(error.response.data.errors).toString().replace(',', ' ')
      }
      return Promise.reject(errorMessage);
    }
    return Promise.reject(error);
  });

  return instance;
};

export default axiosInstance();